import React, { useEffect, useRef, useState } from "react";
import "../../../assets/scss/spinStyles.css";
import { useAuth } from "../../../context/authContext";
import { useChat } from "../../../context/chatContext";
import { useChatHistory } from "../../../context/chatHistoryContext";
import Alert from "../alerts/alert";
import { useNavigate, useLocation } from "react-router-dom";
import LogoIcon from "../../../assets/svg/logoIcon";
interface ChatFooterProps {
	addMessage: (text: string, type: string, messageId?: string) => void;
	chat_id: string;
	getResponse: (label: string, chat_id: string, type: string) => void;
	disabled: boolean;
	showNistCards?: boolean;
	showCards: boolean;
	initialQuestion?: string;
}

const ChatFooter: React.FC<ChatFooterProps> = React.memo(
	({
		chat_id,
		addMessage,
		getResponse,
		disabled,
		showNistCards = false,
		showCards,
		initialQuestion
	}) => {
			const { isAuthenticated } = useAuth();
	const { openChatHistory } = useChatHistory();
	const { selectedUseCase, selectedSubCase, startChat } = useChat();
	const [message, setMessage] = useState("");
	const [alertVisible, setAlertVisible] = useState(false);

	const inputRef = useRef<HTMLInputElement>(null);
	const navigate = useNavigate();
	const location = useLocation();

		const handleBackClick = () => {
			window.location.href = "/";
		};
		const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
			setMessage(e.target.value);
		};

		const handleSend = () => {
			// disable if use case is vendor selection and user has not yet elected a subcase...!
			if (selectedUseCase == 3 && !selectedSubCase) {
				addMessage(
					"Please Choose your path before proceeding further.",
					"left"
				);
				setMessage("");
				return;
			}

			if (message.trim()) {
				addMessage(message, "right");
				setMessage("");
				getResponse(message, chat_id, "left");
			}
		};

		const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
			if (e.key === "Enter" && message.length > 0 && !disabled) {
				handleSend();
			}
		};

		const handleAllConversationClick = (
			e: React.MouseEvent<HTMLButtonElement, MouseEvent>
		) => {
			e.preventDefault();
			if (isAuthenticated) {
				openChatHistory();
			} else {
				setAlertVisible(true);
			}
		};

		useEffect(() => {
			if (chat_id !== "" && chat_id.length > 0) {
				if (selectedUseCase === 3 && !selectedSubCase) {
					return;
				} else {
					inputRef?.current?.focus();
				}
			}
		}, [chat_id, selectedSubCase]);

		useEffect(() => {
			console.log(initialQuestion, 'initialQuestion');
			if (initialQuestion) {
				setMessage(initialQuestion);
			}
		}, [initialQuestion]);

		// Handle browser back/forward navigation to clear message input
		useEffect(() => {
			const handlePopState = () => {
				// Clear the message input when user navigates back/forward
				setMessage("");
			};

			// Add event listener for browser navigation
			window.addEventListener('popstate', handlePopState);

			// Cleanup event listener on component unmount
			return () => {
				window.removeEventListener('popstate', handlePopState);
			};
		}, []);

		// Check if we're on the home screen (/chat)
		const isHomeScreen = location.pathname === '/chat';

		return (
			<section className={`${!isHomeScreen ? 'chatfooter' : ''} mt-auto ml-5`}>
				<div className="container-fluid">
					<div className="row justify-content-center">
						<div className="col-md-12">
							{!showCards && (
								<div className="text-center" style={{ marginBottom: "2%" }}>
									<button className="btn btn-link" onClick={handleBackClick}>
										<i className="bi bi-arrow-left me-2"></i>Back
									</button>
								</div>
							)}

							{!showNistCards && (
								<div className="d-flex gap-3 mb-3" style={{ position: "relative" }}>
									{!showCards && (
										<button
											className="btn btn-secondary iconround iconmedium"
											style={{ background: "#205493 !important" }}
											onClick={() => startChat(selectedUseCase)}
										>
											<i className="bi bi-arrow-repeat"></i>
										</button>
									)}
									{
										!showCards && (
											<input
												ref={inputRef}
												type="text"
												className="form-control chatinput"
												placeholder="Ask me a question"
												value={message}
												onChange={handleInputChange}
												onKeyPress={handleKeyPress}
												style={{ paddingRight: "70px", width: "100%" }}
											/>
										)
									}

									{
										!showCards && (
											<button
												className="btn bg-primary"
												style={{ 
													position: "absolute", 
													right: "10px", 
													top: "50%", 
													transform: "translateY(-50%)",
													background: "#26397E !important", 
													zIndex: 10
												}}
												onClick={() => handleSend()}
												disabled={disabled || message.length === 0}
											>
												Send <i
													className={`${
														disabled
															? "bi bi-arrow-clockwise icon-spin"
															: "bi bi-send"
													}`}
												></i>
											</button>
										)
									}
								</div>
							)}
							<div className="d-flex flex-row justify-content-between">
								<div className="text-black d-flex flex-row gap-2" style={{
									// marginLeft: '12%',
									// marginTop: '1%'

								}}>
									Some information about the platform:
									<ul style={{
										listStyleType: 'none',
										paddingLeft: '0',
										marginLeft: '0',
										display: 'flex',
										flexDirection: 'row',
										gap: '10'
									}}>
										<li style={{borderRight: '1px solid black', paddingRight: '10px', textDecoration: 'underline', cursor: 'pointer'}} onClick={() => navigate("/terms-and-conditions")}> Terms & conditions </li>
										<li style={{paddingRight: '10px', textDecoration: 'underline', paddingLeft: '10px', cursor: 'pointer'}} onClick={() => navigate("/privacy-policy")}>Privacy Policy</li>
										{/* <li style={{cursor: 'pointer', paddingLeft: '10px', textDecoration: 'underline'}} onClick={() => navigate("/disclaimer")}>Disclaimer</li> */}
									</ul>
								</div>
								<div className="d-flex flex-row gap-2 align-items-center">
									<div className="text-white px-3">
										Powered By: 
									</div>
									<div className="d-flex align-items-center footer-logo-container">
										<img src="/newLogo.avif" alt="1CISO logo" style={{
											objectFit: 'contain',
											width: '55px',
											height: '25.32px'
											}}/>
									</div>
								</div>
							</div>
							{/* <div className="row">
								<div className="col-3">
									<span>
									<button
										className={`btn btn-link small p-0 ${!isAuthenticated ? "disabled" : ""}`}
										onClick={(e) => handleAllConversationClick(e)}
										disabled={!isAuthenticated}
										style={{
											textDecoration: "none",
											color: "rgb(27, 72, 126)",
											fontSize: "12px",
											fontWeight: 300
										}}
									>
										<i className="bi bi-chat-right-dots"></i> All Conversation
									</button>
									</span>
								</div>
								<div className="col-3">
									<span style={{}}>
										<a className="small" href="/terms-and-conditions">
											Terms and Conditions
										</a>
									</span>
								</div>
								<div className="col-3" style={{ textAlign: "center" }}>
									<span style={{}}>
										<a className="small" href="/privacy-policy">
											Privacy Policy
										</a>
									</span>
								</div>
								<div className="col-3" style={{ textAlign: "center" }}>
									<span style={{}}>
										<a className="small" href="/schedule-consultant">
											Schedule Advisor Discussion
										</a>
									</span>
								</div>
							</div> */}
						</div>
					</div>
				</div>
				<Alert
					message="Loads only when logged in."
					type="warning"
					show={alertVisible}
					onClose={() => setAlertVisible(false)}
				/>
			</section>
		);
	}
);

export default ChatFooter;
